import { Controller } from "@hotwired/stimulus"

// Copies the text content of a source element to the clipboard and briefly
// swaps the "Copy Path" state (icon + label) for a "Copied!" confirmation.
// The button is the flex container; the swappable spans carry no display
// utility so toggling `hidden` reliably shows/hides them.
//
//   div data-controller="clipboard"
//     code data-clipboard-target="source" /forms/spore-test-log/current
//     button data-action="clipboard#copy"
//       span data-clipboard-target="copyState" ...   (icon)
//       span data-clipboard-target="copyState" Copy Path
//       span data-clipboard-target="doneState" class="hidden" ...   (check)
//       span data-clipboard-target="doneState" class="hidden" Copied!
export default class extends Controller {
  static targets = ["source", "copyState", "doneState"]

  copy() {
    const text = this.sourceTarget.textContent.trim()
    navigator.clipboard.writeText(text).then(() => this.flash())
  }

  flash() {
    this.toggle(true)
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.toggle(false), 1500)
  }

  toggle(copied) {
    this.copyStateTargets.forEach((el) => el.classList.toggle("hidden", copied))
    this.doneStateTargets.forEach((el) => el.classList.toggle("hidden", !copied))
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
